define( function() {
	return [];
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/var/arr.js
// module id = 357
// module chunks = 0